module.exports = __webpack_public_path__ + "8a63ca880d0879f3269040a363f7bc15.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-state/class-shelf.png
// module id = 511
// module chunks = 0